import { Input } from "antd";
import React from "react";

export const AntInput = (props) => {
  return (
    <Input
      style={{
        height: "50px",
        borderRadius: "0.75rem",
        ...(props?.style ?? {}),
      }}
      {...props}
    />
  );
};
